import React from 'react';
import { SimplePrice } from '../../../../../brenger-shared-ui';
import { SimplePriceProps } from '../../../../../brenger-shared-ui/components/other/pricedisplay/SimplePrice';
import cn from 'classnames';

export const TermsPrice = ({
  price,
  addPlusMinusIndicator,
  isLoading,
}: SimplePriceProps & { isLoading?: boolean }): JSX.Element => {
  return (
    <div style={{ whiteSpace: 'nowrap' }} className={cn('text-primary', { 'order-overview--is-loading': isLoading })}>
      <SimplePrice price={price} addPlusMinusIndicator={addPlusMinusIndicator} />
    </div>
  );
};
